export default {
  SET_LANGUAGE(state, payload) {
    state.lang = payload
  },
  SET_LOCALES(state, langs) {
    state.locales = langs
  },
}
